/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_CtaInputs */

const en_simple_oto_cta = /** @type {(inputs: Simple_Oto_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start from your idea`)
};

const id_simple_oto_cta = /** @type {(inputs: Simple_Oto_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari idemu`)
};

/**
* | output |
* | --- |
* | "Start from your idea" |
*
* @param {Simple_Oto_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_cta = /** @type {((inputs?: Simple_Oto_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_cta(inputs)
	return en_simple_oto_cta(inputs)
});